// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yn1rC{flex:1;display:flex;flex-direction:column;min-height:0}.kU5GD{flex:1}.iWyy5{display:flex;flex-direction:column;min-height:0;overflow:hidden}.gG7IL{display:flex;flex-direction:column;min-height:0;overflow:hidden}.re0pt{flex:1;min-height:0;overflow:hidden;position:relative}.GyAAl{flex:1;min-height:0;overflow-y:auto;padding:24px}.ubClt{flex:1;min-height:0;justify-content:flex-start;align-items:center;container-type:size}.Zm41Z{aspect-ratio:16/9;width:min(100%,177.7777777778cqh)}.dflg7{aspect-ratio:16/9;width:min(100%,177.7777777778cqh);display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Yn1rC`,
	"card": `kU5GD`,
	"cardPdf": `iWyy5`,
	"cardText": `gG7IL`,
	"content": `re0pt`,
	"richTextContentWrapper": `GyAAl`,
	"videoRoot": `ubClt`,
	"videoWrapper": `Zm41Z`,
	"loaderWrapper": `dflg7`
};
export default ___CSS_LOADER_EXPORT___;
